import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Helpers
import { confirm, toggleDrawer, pushHrefToRouting } from '../../helpers/helpers.js'

// Dependencies
import Delayed from 'react-delayed';
import { FeatureFlag } from 'react-launch-darkly';

// Components
import * as icons from '../Icons/Icons';
import FundingRulesList from './FundingRulesList';
import Drawer from '../Drawer/Drawer';
import Toolbar from '../Common/Toolbar';

const FundingRules = observer(class FundingRules extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.addRule = this.addRule.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.deleteFundingRules = this.deleteFundingRules.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.renderEditMessage = this.renderEditMessage.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      fundingRuleSid: null,
      selectedRows: []
    }
  }

  getFilteredFundingRules(scope, sid) {
    this.props.store.FundingRuleStore.getFilteredFundingRules(scope, sid);
  }

  getFundingRules() {
    this.props.store.FundingRuleStore.getFundingRules(true);
  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;
    const { SessionStore } = this.props.store;

    if(pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
      SessionStore.loading = false;
      toggleDrawer(null, this, 'AddFundingRule');
    }

    if(pathname.indexOf('edit') > -1) {
      let fundingRuleSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      if(!fundingRuleSid && this.props.fundingRuleSid) {
        fundingRuleSid = this.props.fundingRuleSid;
      }

      this.setState({
        fundingRuleSid
      });
    }
  }

  addRule() {
    this.props.parent.setState({
      drawerContent: 'AddFundingRule'
    });

    if(this.props.fundingRuleSid && this.props.parent) {
      this.props.parent.setState({
        fundingRuleSid: null
      });
    }
  }

  handleAdd(e) {
    e.preventDefault();
    // If drawer is not open push the event href to routing path
    if(!this.props.drawer) {
      pushHrefToRouting(e.target.href, this);
    } else {
      this.props.parent.setState({
        drawerContent: 'AddFundingRule'
      })
    }
  }

  deleteFundingRules() {
    const { translation } = this.props;

    let msg = {
      heading: `${translation.delete_confirm.heading_singular}`,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }

    const { query } = this.props.routing.location;

    let callback = null;

    if(query.fundingRuleScope && query.scopeSid) {
      callback = () => this.getFilteredFundingRules(query.fundingRuleScope, query.scopeSid);
    } else if(this.props.offeringSid) {
      callback = () => this.getFilteredFundingRules('courseOfferingSid', this.props.offeringSid);
    } else {
      callback = () => this.getFundingRules();
    }

    // Loop through all the selected funding rules and send delete API request
    const _this = this;

    confirm(
      msg,
      () => {
        for(let i = 0; i < _this.state.selectedRows.length; i++) {
          _this.props.store.FundingRuleStore.deleteFundingRule(
            _this.state.selectedRows[i],
            callback
          )
        }

        _this.setState({
          selectedRows: []
        });
      }
    );
  }

  renderAddButton() {
    const { translation } = this.props;

    return (
      <Link
        className="btn--outline"
        to="funding-rules/add"
        onClick={(e) => this.handleAdd(e)}
      >
        <icons.iconPlus />
        {translation.add_funding_rule}
      </Link>
    )
  }

  renderEditMessage() {
    const { translation } = this.props;

    return (
      <div className="cta">
        <strong className="cta__copy">
          {translation.edit.heading}
        </strong>

        <span className="cta__subcopy">
          {translation.edit.body}
        </span>

        <a
          className="cta__btn btn--icn-right"
          href="mailto:sean@smarterservices.com"
        >
          {translation.edit.button}
        </a>
      </div>
    )
  }

  render() {
    const { translation } = this.props;

    if(this.props.drawer) {
      const { fundingRuleScope } = this.props.routing.location.query;

      let rulesFor = translation.for_course;

      if(fundingRuleScope === 'examSid') {
        rulesFor = this.props.exam.title;
      }

      if(fundingRuleScope === 'enrollmentSid') {
        rulesFor = this.props.enrollmentName;
      }

      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">
                {translation.page_title} {translation.rules_for} {rulesFor}
              </h1>

              <button
                className="btn--outline"
                onClick={this.addRule}
              >
                <icons.iconPlus />
                {translation.add_funding_rule}
              </button>
            </div>
          </header>

          <div className="wrap">
            <FundingRulesList
              {...this.props}
              parent={this}
              selectedRows={this.state.selectedRows}
            />

            <Delayed
              mounted={this.state.selectedRows.length > 0}
              unmountAfter={250}
            >
              <Toolbar
                selectedRows={this.state.selectedRows}
                deleteText={translation.delete}
                deleteFunction={this.deleteFundingRules}
                {...this.props}
              />
            </Delayed>
          </div>
        </div>
      )
    } else {
      return (
        <main tabIndex="0" id="main-content" className="page">
          <header className="page__header">
            <div className="wrap">
              <h1 className="page__title">{translation.page_title}</h1>

              <div className="page__actions actions">
                <FeatureFlag
                  flagKey="global-funding-rules"
                  renderFeatureCallback={this.renderAddButton}
                  renderDefaultCallback={null}
                />
              </div>
            </div>
          </header>

          <div className="wrap">
            <FundingRulesList
              selectedRows={this.state.selectedRows}
              parent={this}
              {...this.props}
            />

            <FeatureFlag
              flagKey="global-funding-rules"
              renderFeatureCallback={() => {return null}}
              renderDefaultCallback={this.renderEditMessage}
            />
          </div>

          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this}
            {...this.props}
            fundingRuleSid={this.state.fundingRuleSid}
          />

          <Delayed
            mounted={this.state.selectedRows.length > 0}
            unmountAfter={250}
          >
            <Toolbar
              selectedRows={this.state.selectedRows}
              deleteText={translation.delete}
              deleteFunction={this.deleteFundingRules}
              {...this.props}
            />
          </Delayed>
        </main>
      )
    }
  }
})

export default translate('FundingRules')(FundingRules);



// WEBPACK FOOTER //
// ./src/app/components/FundingRules/FundingRules.js